export const getAlertStyle = () => ({
  root: {
    marginTop: 20,
    marginBottom: 12,
    '& .alert-image': {
      marginTop: 3,
    },
    '& .alert-info-inline': {
      width: '100%',
      '& a': {
        marginTop: 2,
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'none',
      },
      '& .glyphicon': {
        float: 'right',
        top: 4,
        color: '#605E5C',
        fontSize: 16,
      },
    },

  },
});
